import { ACCENTED_SPELLINGS } from '../constants/accented-spellings'

/** The accented spelling `word` should have, in `word`'s capitals, or `undefined` when it needs none. */
export function accentedSpellingOf(word: string): string | undefined {
  const accented = ACCENTED_SPELLINGS.get(word.toLowerCase())

  if (!accented) return undefined
  if (word === word.toUpperCase()) return accented.toUpperCase()
  if (word[0] === word[0]?.toUpperCase()) return accented[0]!.toUpperCase() + accented.slice(1)

  return accented
}
